/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Fulldownloaddelta2Inputs */

const id_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan unduhan penuh`)
};

const ms_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan muat turun penuh`)
};

const da_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændring i fuld download`)
};

const de_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung des vollständigen Downloads`)
};

const en_us2_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full download change`)
};

const es_es2_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de descarga completa`)
};

const es_mx2_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de descarga completa`)
};

const fil_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago sa buong download`)
};

const fr_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variation du téléchargement complet`)
};

const it_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variazione del download completo`)
};

const hu_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes letöltés változása`)
};

const nl_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijziging in volledige download`)
};

const no_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endring i full nedlasting`)
};

const pl_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana pełnego pobierania`)
};

const pt_br2_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração do download completo`)
};

const pt_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração da transferência completa`)
};

const ro_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificarea descărcării complete`)
};

const fi_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täyden latauksen muutos`)
};

const sv_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändring av fullständig nedladdning`)
};

const vi_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi tải xuống đầy đủ`)
};

const tr_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam indirme değişikliği`)
};

const cs_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna úplného stažení`)
};

const bg_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна в пълното изтегляне`)
};

const ru_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение полного размера загрузки`)
};

const uk_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна повного завантаження`)
};

const ar_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير التنزيل الكامل`)
};

const hi_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण डाउनलोड में बदलाव`)
};

const th_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงการดาวน์โหลดทั้งหมด`)
};

const ja_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全ダウンロードの変化`)
};

const zh_cn2_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下载变化`)
};

const zh_hant1_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下載變更`)
};

const ko_builds_comparison_fulldownloaddelta2 = /** @type {(inputs: Builds_Comparison_Fulldownloaddelta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 다운로드 변경`)
};

/**
* | output |
* | --- |
* | "Full download change" |
*
* @param {Builds_Comparison_Fulldownloaddelta2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_fulldownloaddelta2 = /** @type {((inputs?: Builds_Comparison_Fulldownloaddelta2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Fulldownloaddelta2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "ms") return ms_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "da") return da_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "de") return de_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "fil") return fil_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "fr") return fr_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "it") return it_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "hu") return hu_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "nl") return nl_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "no") return no_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "pl") return pl_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "pt") return pt_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "ro") return ro_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "fi") return fi_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "sv") return sv_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "vi") return vi_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "tr") return tr_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "cs") return cs_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "bg") return bg_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "ru") return ru_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "uk") return uk_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "ar") return ar_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "hi") return hi_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "th") return th_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "ja") return ja_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_fulldownloaddelta2(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_fulldownloaddelta2(inputs)
	return ko_builds_comparison_fulldownloaddelta2(inputs)
});
export { builds_comparison_fulldownloaddelta2 as "builds.comparison.fullDownloadDelta" }